import React, { useEffect, useState } from "react";
import {
  Container,
  Card,
  Alert,
  CardBody,
  Button,
  Form,
} from "reactstrap";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { fetchProfile, editUser } from "../../slices/thunks";
import { resetProfileFlag } from "../../slices/auth/profile/reducer";
import NameInput from "../../common/NameInput";
import EmailInput from "../../common/EmailInput";
import PasswordInput from "../../common/PasswordInput";
import BreadCrumb from "../../Components/Common/BreadCrumb";

const UserProfile = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.Profile.user);
  const [formValues, setFormValues] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    dispatch(fetchProfile());

    return () => {
      dispatch(resetProfileFlag());
    };
  }, [dispatch]);

  useEffect(() => {
    if (user && (user.firstName || user.email)) {
      setFormValues({
        firstName: user.firstName || "",
        lastName: user.lastName || "",
        email: user.email || "",
        password: "",
      });
    }
  }, [user]);

  // Log user profile data for debugging
  useEffect(() => {
    console.log('User profile data:', user);
  }, [user]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: formValues || {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.firstName) {
        errors.firstName = "First Name is required";
      }
      if (!values.lastName) {
        errors.lastName = "Last Name is required";
      }
      if (!values.email) {
        errors.email = "Email is required";
      }
      if (values.password && values.password.length < 6) {
        errors.password = "Password must be at least 6 characters";
      }
      return errors;
    },
    onSubmit: async (values) => {
      try {
        setIsSubmitting(true);
        const payload = {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
        };
        if (values.password && values.password.trim() !== "") {
          payload.password = values.password;
        }
        const response = await dispatch(editUser({
          id: user.id,
          ...payload
        }));
        console.log("Profile update response:", response);
        if (response.payload) {
          await dispatch(fetchProfile());
          validation.setFieldValue("password", "");
        } else {
          // toast.error("Failed to update profile. Please try again.", {
          //   position: "top-right",
          //   autoClose: 2000,
          // });
        }
      } catch (error) {
        // toast.error("An error occurred. Please try again.", {
        //   position: "top-right",
        //   autoClose: 3000,
        // });
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  if (!formValues) return <Alert color="info">Loading profile...</Alert>;

  return (
    <React.Fragment>
      {/* <ToastContainer /> */}
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Edit Profile" pageTitle="Edit Profile" />


          <div className="mt-lg-5">
            <Card>
              <CardBody>
                <Form onSubmit={validation.handleSubmit}>
                  <NameInput
                    name="firstName"
                    id="firstName"
                    label="First Name"
                    required={true}
                    value={validation.values.firstName}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    error={
                      validation.touched.firstName &&
                      validation.errors.firstName
                    }
                  />
                  <br />
                  <NameInput
                    name="lastName"
                    id="lastName"
                    label="Last Name"
                    required={true}
                    value={validation.values.lastName}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    error={
                      validation.touched.lastName &&
                      validation.errors.lastName
                    }
                  />
                  <br />
                  <EmailInput
                    name="email"
                    id="email"
                    required={true}
                    layout="below"
                    disabled={true}
                    value={validation.values.email}
                  />
                  <br />

                  <PasswordInput
                    name="password"
                    id="password"
                    required={false}
                    layout="below"
                    placeholder="Enter new password"
                    helpText="Leave blank to keep current password."
                    value={validation.values.password}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    error={
                      validation.touched.password &&
                      validation.errors.password
                    }
                  />

                  <div className="text-center mt-4">
                    <Button
                      className="add-button-margin"
                      type="submit"
                      style={{ backgroundColor: "#5962ef" }}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Updating..." : "Update Profile"}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserProfile;
